module.exports = __webpack_public_path__ + "img/padecimientoIcono.eec576db.svg";